// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Unified Statistics Styles
 * Consistent statistics cards for all management pages
 */

/* Unified Statistics Grid */
.unified-stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
    padding: 25px;
    margin-bottom: 30px;
}

/* Unified Stat Card */
.unified-stat-card {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.05);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
}

.unified-stat-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #EA580C, #FDBA74, #FB923C);
    border-radius: 16px 16px 0 0;
}

.unified-stat-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.unified-stat-card h3 {
    color: #2d3748;
    font-size: 1rem;
    font-weight: 600;
    margin: 0 0 12px 0;
    line-height: 1.3;
    display: flex;
    align-items: center;
    gap: 8px;
}

.unified-stat-card .unified-stat-number {
    color: #2d3748;
    font-size: 2.5rem;
    font-weight: 700;
    margin: 0 0 8px 0;
    line-height: 1;
    background: linear-gradient(135deg, #EA580C, #FDBA74);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.unified-stat-card .unified-stat-subtitle {
    color: #718096;
    font-size: 0.875rem;
    font-weight: 500;
    margin: 0;
    line-height: 1.4;
}

/* Responsive Design */
@media (max-width: 768px) {
    .unified-stats-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
        padding: 20px;
    }

    .unified-stat-card {
        padding: 20px;
    }

    .unified-stat-card h3 {
        font-size: 1rem;
    }

    .unified-stat-card .unified-stat-number {
        font-size: 1.5rem;
    }

    .unified-stat-card .unified-stat-subtitle {
        font-size: 0.8rem;
    }
}

@media (max-width: 480px) {
    .unified-stats-grid {
        grid-template-columns: 1fr;
        gap: 12px;
        padding: 15px;
    }

    .unified-stat-card {
        padding: 16px;
    }

    .unified-stat-card h3 {
        font-size: 0.9rem;
    }

    .unified-stat-card .unified-stat-number {
        font-size: 1.3rem;
    }

    .unified-stat-card .unified-stat-subtitle {
        font-size: 0.75rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/common/UnifiedStats.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,4BAA4B;AAC5B;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,aAAa;IACb,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,qCAAqC;IACrC,iDAAiD;IACjD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,6DAA6D;IAC7D,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,qDAAqD;IACrD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI;QACI,qCAAqC;QACrC,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/**\n * Unified Statistics Styles\n * Consistent statistics cards for all management pages\n */\n\n/* Unified Statistics Grid */\n.unified-stats-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 20px;\n    padding: 25px;\n    margin-bottom: 30px;\n}\n\n/* Unified Stat Card */\n.unified-stat-card {\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(10px);\n    border-radius: 16px;\n    padding: 24px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n    border: 1px solid rgba(0, 0, 0, 0.05);\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    position: relative;\n    overflow: hidden;\n}\n\n.unified-stat-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 4px;\n    background: linear-gradient(90deg, #EA580C, #FDBA74, #FB923C);\n    border-radius: 16px 16px 0 0;\n}\n\n.unified-stat-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\n}\n\n.unified-stat-card h3 {\n    color: #2d3748;\n    font-size: 1rem;\n    font-weight: 600;\n    margin: 0 0 12px 0;\n    line-height: 1.3;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.unified-stat-card .unified-stat-number {\n    color: #2d3748;\n    font-size: 2.5rem;\n    font-weight: 700;\n    margin: 0 0 8px 0;\n    line-height: 1;\n    background: linear-gradient(135deg, #EA580C, #FDBA74);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.unified-stat-card .unified-stat-subtitle {\n    color: #718096;\n    font-size: 0.875rem;\n    font-weight: 500;\n    margin: 0;\n    line-height: 1.4;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .unified-stats-grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 16px;\n        padding: 20px;\n    }\n\n    .unified-stat-card {\n        padding: 20px;\n    }\n\n    .unified-stat-card h3 {\n        font-size: 1rem;\n    }\n\n    .unified-stat-card .unified-stat-number {\n        font-size: 1.5rem;\n    }\n\n    .unified-stat-card .unified-stat-subtitle {\n        font-size: 0.8rem;\n    }\n}\n\n@media (max-width: 480px) {\n    .unified-stats-grid {\n        grid-template-columns: 1fr;\n        gap: 12px;\n        padding: 15px;\n    }\n\n    .unified-stat-card {\n        padding: 16px;\n    }\n\n    .unified-stat-card h3 {\n        font-size: 0.9rem;\n    }\n\n    .unified-stat-card .unified-stat-number {\n        font-size: 1.3rem;\n    }\n\n    .unified-stat-card .unified-stat-subtitle {\n        font-size: 0.75rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
